import { DependencyList, useEffect, useState } from 'react';

const getColorFromElement = (element?: Element | null, end: boolean = false) => {
	if (!element) return;

	let target: Element | undefined;
	if (element.classList.contains('colorWrapperAnimatedModule')) {
		target = element;
	} else if (!end) {
		target = element.querySelector('div[class*="colorWrapperAnimatedModule"]') || undefined;
	} else {
		const elements = Array.from(element.querySelectorAll('div[class*="colorWrapperAnimatedModule"]'));
		target = elements[elements.length - 1] || undefined;
	}

	if (!target) return;

	return window.getComputedStyle(target).backgroundColor || undefined;
};

export type SurroundingColors = [string | undefined, string | undefined];

export function useSurroundingColors(
	target: React.RefObject<Element | null>,
	deps: DependencyList = [],
	preset: SurroundingColors = [undefined, undefined]
) {
	const [backgroundColors, setBackgroundColors] = useState<[string | undefined, string | undefined]>(preset);

	useEffect(() => {
		const prevColor = preset[0] || getColorFromElement(target.current?.previousElementSibling, true);
		const nextColor = preset[1] || getColorFromElement(target.current?.nextElementSibling);

		setBackgroundColors([
			prevColor || nextColor || undefined, // [0] = prevColor, fallback to nextColor
			nextColor || prevColor || undefined, // [1] = nextColor, fallback to prevColor
		]);
	}, [target.current, ...deps]);

	return backgroundColors;
}
